import { neutral } from '@alphorm/ui'

export default {
  funding: {
    display: 'flex',
    alignItems: 'center'
  },
  tag: {
    border: `1px solid ${neutral[4]}`,
    borderRadius: 4
  },
  linkClass: {
    textDecoration: 'none',
    lineHeight: 0,
    color: neutral[0]
  }
}
